// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__FFpgk","logo-img":"Logo_logo-img__qBHA0","name":"Logo_name__TV2vI"};